const palette = {
  mode: "light",
  "grey[100]": "#f5f5f5",
  primary: {
    light: "#5D80C8",
    main: "#4267b2",
    dark: "#1e1b18",
  },
  secondary: {
    light: "#ffffff",
    main: "#dedef2",
    dark: "#f8f8fb",
  },
  error: {
    light: "#ef5350",
    main: "#d32f2f",
    dark: "#c62828",
  },
  warning: {
    light: "#ff9800",
    main: "#ed6c02",
    dark: "#e65100",
  },
  info: {
    light: "#03a9f4",
    main: "#0288d1",
    dark: "#0288d1",
  },
  Success: {
    light: "#4caf50",
    main: "#2e7d32",
    dark: "#1b5e20",
  },
};

export default palette;
